// extracted by mini-css-extract-plugin
export var pillWrapper = "_p1-0";
export var showOverflow = "_p1-1";